import { FlexLayout, H4 } from '@deity/falcon-ui';
import type { FC } from 'react';
import { ContentType, Host, Method, Path, Protocol } from './Properties';

interface ConfigurationProps {
  isEditable: boolean;
  protocol: 'http' | 'https';
  method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';
  contentType: 'application/json';
  host: string;
  path: string;
  onChange: (key: string[], val: any, set?: boolean) => void;
}
const Configuration: FC<ConfigurationProps> = ({ isEditable, onChange, protocol, method, contentType, host, path }) => (
  <FlexLayout p="xxl" flexDirection="column">
    <H4 fontWeight="semiBold" fontSize="xl">
      Configuration
    </H4>
    <Protocol protocol={protocol} onChange={onChange} isEditable={isEditable} />
    <Method style={{ width: '50%' }} method={method} onChange={onChange} isEditable={isEditable} />
    <ContentType contentType={contentType} onChange={onChange} isEditable={isEditable} />
    <Host protocol={protocol} host={host} onChange={onChange} isEditable={isEditable} />
    <Path path={path} onChange={onChange} isEditable={isEditable} />
  </FlexLayout>
);

export default Configuration;
